<template>
  <el-dropdown trigger="click" style=" cursor: pointer;" class="international" @command="handleSetLanguage">
    <div class="iconbox">
      <svg-icon class-name="international-icon" icon-class="language" />
      <div class="lang">{{$t('dashboard.index.lang')}}</div>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language === 'zh'" command="zh"> 简体中文 </el-dropdown-item>
      <el-dropdown-item :disabled="language === 'yue'" command="yue"> 繁體中文 </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
  export default {
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    props: {
      langstr: String
    },
    mounted() {
      // this.$store.dispatch('app/setLanguage', this.langstr)
      // this.$emit('changelang', this.langstr)
    },
    methods: {
      handleSetLanguage(lang) {
        this.$i18n.locale = lang
        this.$store.dispatch('app/setLanguage', lang)
        console.log('lang', this.$store.getters.language)
        this.$emit('changelang', lang)
        if (lang === 'yue') {
          this.$message({
            message: '語言切換成功',
            type: 'success'
          })
        } else if (lang === 'zh') {
          this.$message({
            message: '语言切换成功',
            type: 'success'
          })
        }
      }
    }
  }
</script>
<style>
  /deep/ .el-dropdown-menu__item {
    font-size: 50px !important;
  }
</style>